<template>
	<core-button
		v-bind="$attrs"
		v-on="$listeners"
		:href="upgradeUrl"
		target="_blank"
	>
		<slot>Upgrade Now &amp; Save 35%</slot>
	</core-button>
</template>
<script lang="js">
import { featureMap } from '@/wizard/data'

export default  {
	inheritAttrs : false,
	props        : {
		utmMedium : {
			type     : String,
			required : true,
		},
		features : {
			type    : Array,
			default : () => [],
		},
	},
	computed : {
		upgradeUrl () {
			// Get non-plugin features.
			const features = this.features.filter(f => {
				const found = !featureMap.find(m => m.slug === f)
				return !found || !found.plugin
			})

			return this.$urls.upgrade({ utm_medium: this.utmMedium }, features)
		},
	},
}
</script>
